import React from 'react'
import { createRoot } from 'react-dom/client'

import Router from './router'
import routes from './router/routes'
import Store from './store'

import {
  isDevelopment,
} from '@kaidam/fc-shared/src/utils/settings'

// use to save the state to local storage for
// quick debugging of redux
if(isDevelopment()) {
  (window as any).__saveState = () => {
    const data = JSON.stringify(store.getState(), null, 4)
    localStorage.setItem('fc_state', data)
  }
  
  (window as any).__clearState = () => {
    localStorage.removeItem('fc_state')
  }

  const existingData = localStorage.getItem('fc_state')

  if(existingData) {
    // we need to adjust a few things in the loaded state
    // otherwise we don't go through the initialise phase on page load
    const parsedData = JSON.parse(existingData)
    const w = window as any
    parsedData.system.initialised = false
    w.__INITIAL_STATE__ = parsedData
  }
}

const initialState: Record<string, any> = (window as any).__INITIAL_STATE__ || {}

const router = Router(routes)

const store = Store({
  router,
  initialState,
})

const rootEl = document.querySelector('#root')

let render = () => {
  const RootAppComponent = require('./root').default
  const root = createRoot(rootEl)
  root.render(
    <RootAppComponent
      store={ store }
      router={ router }
    />
  )
}

render()
